// Application Constants
export const CONTACT_INFO = {
  PHONE: '+6282386303140 (Mario)',
  
  ADDRESS: 'Jl. Bogor Raya City, Katulampa, Kec. Bogor Tim., Kota Bogor, Jawa Barat 10160'
};

export const COMPANY_INFO = {
  NAME: 'The Mutiara Bogor',
  COPYRIGHT: '© 2025 The Mutiara Bogor. All Rights Reserved.',
  POWERED_BY: 'Powered by: Linktown'
};

export const NAVIGATION_LINKS = {
  ABOUT: '/#about',
  PROMO: '/#promo',
  RESIDENTIAL: '/#residential',
  FACILLITIES: '/#fasilitas',
  LOCATION: '/#lokasi',
  NAVBAR: '/#navbar',
  PRIVACY_POLICY: '/privacy-policy',
  REFUND_POLICY: '/privacy-policy/#refund',
  DISCLAIMER: '/privacy-policy/#disclaimer'
};
